/**
 * Chinese Disclaimer.
 * @format
 */

import React from 'react';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import Checkbox from './checkbox';
import Link from '@base-components/buttons/link';
import { useSafeTranslate } from '@hooks/use-safe-translate';

type ChineseDisclaimerProps = {
  register: UseFormRegister<FieldValues>;
  errors?: { [key: string]: FieldErrors };
};

const ChineseDisclaimer: React.FC<ChineseDisclaimerProps> = ({
  register,
  errors,
}) => {
  return (
    <div className="form-disclaimer">
      <p className="font-bold">
        请仔细阅读
        <Link
          url="https://www.varian.com/zh-hans/about-varian/legal-information/china-privacy-statement"
          linkText="《瓦里安医疗系统公司隐私声明》"
          openNewWindow={true}
        />
        内容
      </p>
      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'dataPrivacyConsent',
          errorMessage: '必填字段',
          required: true,
          htmlLabel: true,
          list: [
            {
              name: 'consent',
              value: 'consent',
              label:
                '我同意瓦里安根据以上《隐私声明》对我提供的个人信息进行处理',
            },
          ],
        }}
        register={register}
        errors={errors}
      />
      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'disclaimer-2',
          errorMessage: '必填字段',
          required: true,
          htmlLabel: true,
          list: [
            {
              name: 'disclaimer-2',
              value: 'disclaimer-2',
              label:
                '我同意瓦里安根据以上《隐私声明》，为联系我或处理我的咨询之目的向境外接收方跨境传输我提供的个人信息',
            },
          ],
        }}
        register={register}
        errors={errors}
      />

      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'Email_Opt_in__c',
          errorMessage: '必填字段',
          required: false,
          htmlLabel: true,
          list: [
            {
              name: 'consent',
              value: 'consent',
              label: useSafeTranslate(
                'I agree to receive communications based on my personal interests and interactions with Siemens Healthineers, as described in the Privacy Notice. I can withdraw my consent any time, with future effect, by unsubscribing.'
              ),
            },
          ],
        }}
        register={register}
        errors={errors}
      />
    </div>
  );
};
export default ChineseDisclaimer;
